module.exports = __webpack_public_path__ + "front/img/kv_offline.da9cec2d.png";